import { useEffect } from 'react'
import { areEq, getStoredValue, storeValue } from './utils/localStrorageUtils'

/**
 * Custom hook to manage the beta workspace flag using url query parameters.
 * @param location - Optional query string containing the beta workspace flag.
 * @returns An object containing the beta workspace flag.
 */
export const useBetaWorkspaceFlag = (location?: string) => {
    const isBetaWorkspaceEnabled = areEq(
        getStoredValue('enableBetaWorkspace')?.toString(),
        'true'
    )

    // CRITICAL: Always call useEffect to maintain consistent hook order
    // Even if location is not provided, we must call useEffect (it just won't do anything)
    useEffect(() => {
        // Only process if location is provided
        if (!location) {
            return
        }

        // Check the query params and update the persisted value
        const queryParams = new URLSearchParams(location)
        const enableBetaWorkspace = queryParams.get('enableBetaWorkspace')

        if (enableBetaWorkspace) {
            const parsedValue =
                areEq(enableBetaWorkspace, 'true') ||
                areEq(enableBetaWorkspace, '1')

            // persist enableBetaWorkspace in localStorage
            storeValue('enableBetaWorkspace', parsedValue)
        }
    }, [location])

    return { isBetaWorkspaceEnabled }
}
